import React from 'react'

export default function Empty({children = '—'}) {
    return <span className="empty">{children}</span>
}
